import { AveragePriceAction } from './average-price.action';

export class AveragePriceList {
    /**
     * Preço médio do ativo em custódia do assessorado
     */
    public quantity: number;
    public date: string;
    public cblc: number;
    public price: number;
    public ticker: string;
}

export class AveragePriceState {
    public custodyAveragePrice: AveragePriceList[];
    public pending: boolean;
    public error: string;
}

export const initialState: AveragePriceState = {
    custodyAveragePrice: [],
    pending: false,
    error: null
};

export function AveragePriceReducer(
    state: AveragePriceState = initialState,
    action?: AveragePriceAction,
): AveragePriceState {
    switch (action.type) {

        case AveragePriceAction.getCustodyAveragePrice:
            return { ...state, ...{ pending: true } };
        case AveragePriceAction.getCustodyAveragePriceError:
            return { ...state, ...{ pending: false, error: action.payload, custodyAveragePrice: [] } };
        case AveragePriceAction.getCustodyAveragePriceSuccess:
            return { ...state, ...{ pending: false, custodyAveragePrice: action.payload } };

        default:
            return state;
    }
}
